import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import env from '../env';

const categoriesApi = createApi({
    reducerPath: 'categories',
    baseQuery: fetchBaseQuery({
        baseUrl: env.baseUrl
    }),
    endpoints(builder) {
        return {
            getCategories: builder.query({
                query: () => {
                    return {
                        url: '/categories',
                        method: 'GET',
                    };
                }
            })
        };
    }
});

export const {
    useGetCategoriesQuery
} = categoriesApi;
export { categoriesApi };
